var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center subscribe_layout",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"lang-header",on:{"click":function($event){return _vm.changeLang()}}},[_c('p',[_vm._v(_vm._s(this.$i18n.locale.toUpperCase()))])]),_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }